import React from "react";
import { Image } from "@project-stories/elements/Image/Image";

export function HeaderLogo({ settings, className = "" }) {
  return (
    <div className={`header-logo-container ${className}`}>
        {settings.globals.logo &&
            <div className={`flex flex-col gap-[8px]`}>
                <a href="/" className="header-logo-image lg:pb-0">
                    <Image
                        imageUrl={settings.globals.logo}
                        alt="Header logo"
                        isLazy={false}
                        width={settings.globals.logo_width}
                        height={settings.globals.logo_height}
                        classes={"w-[108px] lg:w-[161px]"}
                    />
                </a>
            </div>
        }

        <a href="/" className="header-logo"
         aria-label="Logo">
        {settings.globals.shop_title}
      </a>
    </div>
  );
}
